export enum DownloadsEnum {
  Manual = "manual",
  BhapticsPlayer = "bhaptics_player",
}

/**
 * **없어진 탭의 옛 `?type=` 값 → 대신 보낼 탭.**
 *
 * `bhaptics_studio` 탭은 2026-09-29 에 걷었다(작성자 지시). 밖에 남은 옛 링크(메일 · 문서 ·
 * 즐겨찾기)는 Studio 를 찾던 **소프트웨어 사용자**라 Manual 보다 Player 탭이 가깝다(작성자 결정).
 */
export const LEGACY_DOWNLOAD_TYPES: Readonly<Record<string, DownloadsEnum>> = {
  bhaptics_studio: DownloadsEnum.BhapticsPlayer,
};

/**
 * **`?type=` → 보여줄 탭.** 다운로드 페이지의 판정은 전부 이 함수 하나다.
 *
 * ```
 *   manual · bhaptics_player        → 그대로
 *   없음(undefined · "")             → Player   ← 구 PC Player · 신 PCP 이관 설치기 · 옛 주소
 *   없어진 탭의 옛 값                  → LEGACY_DOWNLOAD_TYPES
 *   그 밖(?type=foo · 대소문자 · 배열)  → Manual   ← #5025 크래시 가드의 폴백
 * ```
 *
 * ★**type 이 없으면 Player** 인 이유(2026-09-29 작성자 결정): type 없이 이 페이지를 여는 것은
 * 사실상 **플레이어를 받으러 온 사람**이다 —
 * - 구 PC Player(2.x) 본체 · VRChatOSC 도구가 `www.bhaptics.com/support/downloads` 를 연다
 * - 신 PCP 이관 설치기(`migrate-to-v3.iss`)가 실패 시 *"download the latest version from
 *   www.bhaptics.com/support/downloads"* 라고 안내한다
 * - 옛 주소 `/download` · `/downloads` · `/support/download` 가 type 없이 여기로 온다(`next.config`)
 * 종전 폴백(Manual)은 그 사람들에게 **매뉴얼 목록**을 보여주고 있었다(prod 실측 2026-09-29).
 * 리포 안 링크는 이 기본값에 기대지 않고 `?type=` 을 명시한다 — 기본값이 바뀌면 조용히 다른
 * 탭으로 옮겨 가기 때문이다(`__tests__/components/support/downloads/downloads-links-explicit-type.test.ts`).
 *
 * 엉뚱한 값은 의도를 알 수 없어 종전대로 Manual 이다 — 「없음」과 갈라 둔다.
 *
 * ★**세 곳이 이 함수를 쓴다** — 서버 리다이렉트(`pages/support/downloads.tsx` `handleRedirect`) ·
 * 탭 컨테이너(`Downloads.tsx`) · 레이아웃의 URL 보정(`DownloadsPageLayout.tsx`). 종전엔 셋이
 * **각자** Manual 폴백을 들고 있었다 — 하나만 바꾸면 서버와 화면이 다른 탭을 고른다.
 */
export function resolveDownloadsType(raw: unknown): DownloadsEnum {
  if (raw === undefined || raw === null || raw === "") {
    return DownloadsEnum.BhapticsPlayer;
  }
  if (typeof raw !== "string") return DownloadsEnum.Manual;
  if ((Object.values(DownloadsEnum) as string[]).includes(raw)) {
    return raw as DownloadsEnum;
  }
  return LEGACY_DOWNLOAD_TYPES[raw] ?? DownloadsEnum.Manual;
}
